<form [formGroup]="formGroup">
  <div class="search-container">
    <div class="search">
      <input formControlName="search" type="text" class="search-input" placeholder="Search dishes, cuisines, or chefs"
             name="" i18n-placeholder>
      <div class="search-icon" (click)="openRestaurants()">
        <img src="assets/search-icon.svg" alt="search">
      </div>
    </div>
    <div class="search-results-container">
      <div class="search-result-type" *ngIf="options.merchants.length > 0">
        <p class="search-result-type-title">Restaurants</p>
        <a class="search-result-item" *ngFor="let merchant of options.merchants.slice(0,2)" (click)="goToMerchant(merchant)">
          <img [src]="merchant.profilePictureURL ? merchant.profilePictureURL : 'assets/merchant-placeholder.svg'" class="search-result-item-image" alt="Chef">
          <p class="search-result-item-desc">{{ merchant.name }}</p>
        </a>
        <div (click)="openRestaurants()">
          <p class="see-all-item">See all restaurants results</p>
        </div>
<!--        <div class="separator"></div>-->
      </div>

      <div class="search-result-type"
           *ngIf="options.merchants.isEmpty() && charactersToSearch.hasActualValue() && !fetchingResults">
        <div class="text-center">
          <div class="empty-search-icon"><img src="assets/empty-search-icon.svg"></div>
          <div class="no-results">
            <p i18n="@@noResultsFound">No results found</p>
          </div>
        </div>
      </div>

      <div class="search-result-type" *ngIf="options.products.length > 0">
        <p class="search-result-type-title">Products</p>
        <div class="search-result-item" *ngFor="let product of options.products.slice(0,2)"
             (click)="onOptionSelected(product)">
          <img src="assets/chef-image.png" class="search-result-item-image" alt="Chef">
          <p class="search-result-item-desc">{{ product.name }}r</p>
        </div>
        <div (click)="openProducts()">
          <p class="see-all-item">See all meals results</p>
        </div>
        <div class="separator"></div>
      </div>

      <div class="search-result-type" *ngIf="options.categories.length > 0">
        <p class="search-result-type-title">Categories</p>
        <div class="search-result-item" *ngFor="let category of options.categories.slice(0,2)"
             (click)="onOptionSelected(category)">
          <img src="assets/chef-image.png" class="search-result-item-image" alt="Chef">
          <p class="search-result-item-desc">{{ category.name }}r</p>
        </div>
        <div (click)="openCategories()">
          <p class="see-all-item">See all categories results</p>
        </div>
        <div class="separator"></div>
      </div>
    </div>
  </div>
</form>

